export const LOGIN_LOADING = "auth/login/loading";
export const LOGIN_SUCCESS = "auth/login/success";
export const LOGIN_ERROR = "auth/login/error";
export const LOGIN_ERROR_INAVLID_DETAILS = "auth/login/invalid_details";
export const LOGIN_ERROR_NOT_REGISTERED = "auth/login/not_registered";
export const LOGIN_ERROR_EMPTY_FIELD = "auth/login/empty_field";

export const SIGNUP_LOADING = "auth/signup/loading";
export const SIGNUP_SUCCESS = "auth/signup/success";
export const SIGNUP_ERROR = "auth/signup/error";
export const SIGNUP_ERROR_EXISTS = "auth/signup/exists";
export const SIGNUP_ERROR_CONF_PASSWORD = "auth/signup/conf_password";
export const SIGNUP_ERROR_EMPTY_FIELD = "auth/signup/empty_field";

export const GET_LOGGED_USER = "auth/loggedUser";
export const LOG_OUT = "auth/log_out";
